import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import SelectList from 'components/common/SelectList'
import {
  setActiveEnvironment,
  clearEnvironmentData,
  fetchSensorList,
} from 'reducers/dataBrowser/reducer'
import messages from '../../translate'

class EnvironmentData extends Component {
  componentDidUpdate(prevProps) {
    const { dateRange, activeSite, fetchSensorList } = this.props
    const dateRangeStartDate = dateRange.get('startDate').format('YYYY-MM-DD')
    const dateRangeEndDate = dateRange.get('endDate').format('YYYY-MM-DD')
    const prevDateRangeStartDate = prevProps.dateRange
      .get('startDate')
      .format('YYYY-MM-DD')
    const prevDateRangeEndDate = prevProps.dateRange
      .get('endDate')
      .format('YYYY-MM-DD')
    const dateChanged =
      prevDateRangeStartDate !== dateRangeStartDate ||
      prevDateRangeEndDate !== dateRangeEndDate
    const siteChanged = prevProps.activeSite !== activeSite

    if (dateChanged || siteChanged) {
      fetchSensorList({
        site: activeSite,
        from: dateRange.get('startDate').format('YYYY-MM-DD'),
        to: dateRange.get('endDate').format('YYYY-MM-DD'),
      })
    }
  }

  onEnvChange = data => {
    const { activeEnv, setActiveEnvironment, clearEnvironmentData } = this.props
    if (data !== undefined && data.index !== activeEnv.get('name')) {
      if (data.index !== 0) {
        setActiveEnvironment(data.item)
      } else {
        clearEnvironmentData()
      }
    }
  }

  render() {
    const {
      intl: { formatMessage },
      activeEnv,
      sensorList,
    } = this.props
    const initialValue = { id: 0, name: formatMessage(messages.unselectAll) }

    return (
      <SelectList
        name="environment_data"
        label={formatMessage(messages.environmentData)}
        onChange={this.onEnvChange}
        list={sensorList.unshift(initialValue)}
        value={activeEnv.get('name')}
        map={{
          index: 'name',
          text: 'name',
        }}
      />
    )
  }
}

export default connect(
  state => ({
    activeEnv: state.getIn(['dataBrowser', 'activeEnvironment']),
    sensorList: state.getIn(['dataBrowser', 'sensorList']),
    activeSite: state.getIn(['profile', 'siteId']),
    dateRange: state.getIn(['sensor', 'dateRange']),
  }),
  {
    setActiveEnvironment,
    clearEnvironmentData,
    fetchSensorList,
  },
)(injectIntl(EnvironmentData))
